import { render } from "./ViewSupport.vue?vue&type=template&id=21cf064a&scoped=true"
import script from "./ViewSupport.vue?vue&type=script&lang=js"
export * from "./ViewSupport.vue?vue&type=script&lang=js"

import "./ViewSupport.vue?vue&type=style&index=0&id=21cf064a&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cf064a"]])

export default __exports__